import { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import { getSupportGrant } from "../utils/supportGrant";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

const useSocket = (onReportReady) => {
  const socketRef = useRef(null);
  const [socketConnected, setSocketConnected] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    // Support agents authenticate with a grant token rather than a Cognito
    // access token, so prefer the grant when one is present.
    const supportGrant = getSupportGrant();
    const accessToken = localStorage.getItem("access_token");
    const credential = supportGrant ? { type: "support_grant", token: supportGrant } : accessToken;
    if (!credential) return;

    // Initialize socket without auth in handshake
    const socket = io(SOCKET_URL, {
      transports: ["websocket"],
      withCredentials: true,
      autoConnect: false,
    });

    socketRef.current = socket;

    socket.on("connect", () => {
      setSocketConnected(true);
      // Send the credential via "authenticate" event after connection
      socket.emit("authenticate", credential);
    });

    socket.on("authenticated", () => {
      setAuthenticated(true);
    });

    socket.on("unauthorized", (data) => {
      setAuthenticated(false);
      socket.disconnect();
    });

    socket.on("report_ready", (data) => {
      if (onReportReady) onReportReady(data);
    });

    socket.on("connect_error", (err) => {
      console.error("Socket connection error:", err);
    });

    socket.on("disconnect", () => {
      setSocketConnected(false);
      setAuthenticated(false);
    });

    socket.connect();

    return () => {
      socket.disconnect();
    };
  }, []);

  return { socket: socketRef.current, socketConnected, authenticated };
};

export default useSocket;
